<div class="aberrations-filter-panel">
  <gen-filter-panel-wrapper
    [type]="aberrationFilter?.type"
    [subtype]="aberrationFilter?.subtype"
    [enableStatistics]="aberrationFilter?.enableStatistics"
    [context]="testTypeId"
    class="aberration-filter-open"
    [ngClass]="getFilterPanelstate() ? 'filter-panel-closed':'filter-panel-open'"
    (updatePanelState)="onFilterStateChanges($event)">
  </gen-filter-panel-wrapper>
  <div class="component-wrapper">
    <div class="genomic-aberrations" [ngClass]="getFilterPanelstate() ? 'filter-panel-closed':'filter-panel-open'">
      <div *ngIf="loadModalityContent" class="Flexbox Flexbox__box-align-center Spacebox__lr-large Spacebox__t-small" translate-namespace="aberration">
        <div *ngFor="let modality of testConfiguration.requiredAnnotations; let first = first; let last = last;" class="modality">
          <span class="pointer" id="{{modality.type}}"
                (click)="selectModality(modality)"
                [ngClass]="{'Spacebox__l-regular' : !first, 'selectedModality' : modality.type.toLowerCase() === selectedModalityType?.toLowerCase()}">
            {{modality.label ? getModality(modality.label) : getModality(modality.type)}}
          </span>
          <span *ngIf="modalitiesWithResult.has(modality.type.toLowerCase())" class="middle-dot"
                [ngClass]="{'selectedModality': modality.type.toLowerCase() === selectedModalityType?.toLowerCase()}"></span>
          <span *ngIf="!last" class="Spacebox__l-regular"> | </span>
        </div>
      </div>
      <gen-overlay-loader *ngIf="!loadModalityContent"></gen-overlay-loader>

      <section class="component-section section-height"
               [ngClass]="getFilterPanelstate() ? 'filter-panel-closed' : 'aberrations-when-filter-panel-open'"
               *ngIf="loadModalityContent">
        <gen-immunotherapy *ngIf="selectedModality?.toLowerCase() === 'immunotherapy' || selectedModality?.toLowerCase() === 'other_biomarker'"
                           class="immunotherapy-section"
                           [activeRevisionId]="currentRevision.id"
                           [workflowId]="stateParams.testId"
                           [editAllowed]="immunotherapyEditAllowed"
                           [testType]="testConfiguration.id"
                           (valueUpdate)="updateValues($event, selectedModality)"
                           [listenToEvents]="true"
                           [config]="resourcesConfigs[currentModality]">
        </gen-immunotherapy>

        <div class="genomic-aberrations" *ngIf="!selectedModality || ['wildtype','aberrationtype'].indexOf(selectedModality?.toLowerCase()) > -1 ">

          <!--Aberrations table-->
          <div class="Flexbox Flexbox__just-space-around Flexbox__box-align-center Spacebox__lr-large Spacebox__t-small">

            <div class="Flexbox Flexbox__box-align-center filter-aberrations"
                 *ngIf="resourcesConfigs[currentModality]?.showSelectionSection !== false">

                            <span class="fs5_5 filterCount"
                                  [ngClass]="{'active': aberrationsCtrl.filter == 'all',
                                  'Spacebox__r-tiny': filteredMessage.length > 1, 'Spacebox__r-small': filteredMessage.length == 1 }"
                                  (click)="getAllAberrations();"
                                  genTooltip
                                  [tooltipText]="'Please use filters to refine the results'"
                                  [tooltipPosition]="'BOTTOM'"
                                  [tooltipShow]="isToshowFiltersRefineMsg"
                            >{{ filteredMessage[0].split(" ")[0] | translate }} {{ 'filtered results' | translate }}
                            </span>

              <span *ngIf="filteredMessage.length > 1" class="filterCount aberration-filter"
                    [ngClass]="{'active': aberrationsCtrl.filter == 'all'}">{{filteredMessage[1] | translate}}</span>

              <span class="seperator"></span>

              <span class="title fs5_5 filterCount"
                    [ngClass]="{'active': aberrationsCtrl.filter == 'selected'}"
                    [innerText]="aberrationsCtrl.numberOfSelectedAberrations + transformedValue"
                    (click)="getSelectedAberrations();"></span>

              <!-- If state confirmed show edit button -->
              <button *ngIf="isEditAberrationEnable()"
                      type="button" class="btn-icon edit-result btnHovr" (click)="edit()"
                      genTooltip
                      [tooltipText]="'Edit'"
                      [tooltipPosition]="'RIGHT'"
                      [tooltipShow]="true">
                <span class="glyphicon glyphicon-pencil"></span>
              </button>
            </div>

            <div class="autocomplete Spacebox__r-medium" *ngIf="aberrationsCtrl.filter == 'all'">
              <gen-search-field placeholder="Search aberrations"
                                [autoSearch]="false"
                                [value]="aberrationsCtrl.abberationsSearchText"
                                [loading]="searchLoading"
                                (clearEmit)="cancel()"
                                [removeExtraSpaces]="true"
                                (searchEmit)="search($event)">
              </gen-search-field>
            </div>

            <ng-container *ngIf="canPerformTestActions()">
              <div [ngSwitch]="aberrationsCtrl.currentOpinion?.state" class="abberationActionButton">

                <!--If state is review show confirm button-->
                <!--Disabled if not selected any aberration-->
                <ng-container *ngSwitchCase="'review'">
                  <input *ngIf="!isTestFailed && !jumpToInterpretation() && (!canProceedWithoutAberrationSelection() || aberrationsCtrl.isAnyAberrationSelected)"
                         class="confirm-aberrations btn btn-primary" type="button"
                         value="{{'Confirm Aberrations' | translate}}"
                         [disabled]="!aberrationsCtrl.isAnyAberrationSelected || aberrationsCtrl.updateOpinionOperations > 0"
                         (click)="confirm()"/>
                </ng-container>

                <ng-container *ngSwitchCase="'review'">
                  <input *ngIf="!isTestFailed && canProceedWithoutAberrationSelection() && !aberrationsCtrl.isAnyAberrationSelected"
                         class="confirm-aberrations btn btn-primary Marginbox__l-small" type="button"
                         value="{{'Proceed' | translate}}"
                         (click)="proceedWithSelectedAberrations()"/>
                </ng-container>

                <ng-container *ngSwitchCase="'review'">
                  <input *ngIf="!isTestFailed && jumpToInterpretation()"
                         class="confirm-aberrations btn btn-primary" type="button"
                         value="{{'Release for interpretation' | translate}}"
                         [disabled]="!aberrationsCtrl.isAnyAberrationSelected"
                         (click)="aberrationsReviewToInterpretationJump()"/>
                </ng-container>

                <ng-container *ngSwitchCase="'review'">
                  <div class="Marginbox__l-small"
                       *ngIf="!isTestFailed && jumpToInterpretation() && aberrationsCtrl.isAnyAberrationSelected && aberrationsCtrl.exportAberrationsReportEnabled">
                    <input class="confirm-aberrations btn btn-primary fullWidth" type="button"
                           value="Export selection to Excel"
                           (click)="exportAberrationsToExcel()"
                           title="{{getExportAberrationsTooltip() | translate}}"/>
                  </div>
                </ng-container>

                <!--If state is confirmed and is second opinion show send second opinion button-->
                <ng-container *ngSwitchCase="'confirmed'">
                  <button *ngIf="isSecondOpinion && !isTestFailed"
                          class="confirm-aberrations btn btn-primary" type="button"
                          (click)="sendSecondOpinion()" [disabled]="send2NdOpinionDialogIsOpen">
                    Send 2<sup>nd</sup> opinion
                  </button>
                </ng-container>

                <!-- If orderer and confirmed show list of practitoner to ask and initial report button -->
                <ng-container *ngSwitchCase="'confirmed'">
                  <div *ngIf="aberrationsCtrl.currentOpinion.practitioner?.reference === performer && !isTestFailed;" class="btn-group">
                    <gen-dynamic-form *ngIf="secondOpinionVisible()" class="btn second-opinion-btn"
                                      [formConfig]="secondOpinionForm"
                                      (formChange)="askSecondOpinion($event.form.practitioner)">
                    </gen-dynamic-form>
                    <input *ngIf="!testConfiguration.skipInitialReport"
                           class="select-aberrations btn btn-primary" type="button"
                           value="{{getReleaseReportTitle()}}"
                           (click)="releaseReport()" [disabled]="releaseInitialReportDialogIsOpen"/>
                    <input *ngIf="testConfiguration.skipInitialReport"
                           class="select-aberrations btn btn-primary gap" type="button"
                           value="{{getProceedWithSelectedAberrationsTitle()}}"
                           (click)="proceedWithSelectedAberrations()"
                           [disabled]="clickedOnProceedWithSelectedAberrations"/>
                  </div>
                </ng-container>

                <!--If state is approved and current is the orderer and state is second opinion requested show cancel second opinion button-->
                <ng-container *ngSwitchCase="'approved'">
                  <div *ngIf="aberrationsCtrl.currentOpinion.practitioner.reference == performer && activeJobName.toLowerCase() == '2ndopinionrequested' &&
                        currentRevision.status.toLowerCase() != 'test completed' && !isTestFailed"
                       class="pending-second-opinion">
                    <span class="pending-text">Pending 2<sup>nd</sup> opinion from {{secondOpinioner?.name[0].text}}</span>
                    <button class="cancel-second-opinion" type="button"
                            (click)="cancelSecondOpinion()">
                      Cancel 2<sup>nd</sup> opinion
                    </button>
                  </div>
                </ng-container>

                <!--If state is initial report show/hide button of 2nd opinion history and release final report-->
                <div *ngIf="activeJobName.toLowerCase() == 'initialresults' || statusIsAfterInitialResults">
                  <button
                    class="second-opinion btn btn-default" type="button"
                    (click)="aberrationsCtrl.secondOpinionsVisible = true"
                    *ngIf="aberrationsCtrl.IsExistSecondOpinion  && !aberrationsCtrl.secondOpinionsVisible">
                    View
                    2<sup>nd</sup> opinion
                    history
                  </button>

                  <button
                    class="second-opinion btn btn-default" type="button"
                    (click)="aberrationsCtrl.secondOpinionsVisible = false"
                    *ngIf="aberrationsCtrl.IsExistSecondOpinion  &&  aberrationsCtrl.secondOpinionsVisible == true">
                    Hide
                    2<sup>nd</sup>
                    opinion history
                  </button>

                  <input *ngIf="isProceedAberrationEnable()"
                         (click)="releaseForInterpretation()"
                         class="select-aberrations btn btn-primary"
                         type="button"
                         [disabled]="isProceedAberrationButtonDisabled()"
                         value="{{'Release for interpretation' | translate}}"/>
                  <div *ngIf="isProceedAberrationEnable() && aberrationsCtrl.isAnyAberrationSelected && aberrationsCtrl.exportAberrationsReportEnabled"
                       class="Marginbox__t-small">
                    <input (click)="exportAberrationsToExcel()"
                           title="{{getExportAberrationsTooltip()}}"
                           class="select-aberrations btn btn-primary fullWidth"
                           type="button"
                           [disabled]="isProceedAberrationButtonDisabled()"
                           value="{{'Export selection to Excel' | translate}}"/>
                  </div>

                </div>

              </div>
            </ng-container>

                        <div>
                            <button *ngIf="currentRevision.status.toLowerCase() == 'initial review' && canReassignByRole()"
                                    type="button"
                                    (click)="reassignByRole()"
                                    class="btn btn-primary Flexbox__flex-1 "
                                    class="review-button-color">
                                <span>Initial review done</span>
                            </button>
                        </div>

          </div>

          <div class="Flexbox flex-wrap-wrap Spacebox__l-regular Spacebox__r-medium Spacebox__t-small"
               *ngIf="aberrationsCtrl.filter == 'all' && ['aberrationtype'].indexOf(selectedModality.toLowerCase()) > -1">
            <div *ngFor="let appliedFilter of appliedFilters" class="Spacebox__r-small Spacebox__t-small">
              <gen-applied-filter [filter]=appliedFilter></gen-applied-filter>
            </div>
            <div class="Flexbox Flexbox__just-center Flexbox__box-align-center">
              <span *ngIf="appliedFilters?.length > 0"
                    id="clearAllAppliedFilters"
                    (click)="clearAllAppliedFilters()"
                    class="fs6_5 pointer Spacebox__t-small clearFilter">{{'Clear all filters' | translate}}
              </span>
            </div>
          </div>

          <gen-overlay-loader *ngIf="isShowLoader()"></gen-overlay-loader>

          <div class="aberrations-tables Marginbox__t-medium" id="scrollDiv">
            <article class="result-info Spacebox__l-regular Spacebox__r-medium Flexbox Flexbox__box-direction-column">

              <section class="sticky header Flexbox wordBreak">
                <div class="column Flexbox col-width"></div>

                <ng-container *ngFor="let col of testTableData.displayColumns[currentModality]">
                  <div class="column Flexbox {{col.className}}"
                       [ngClass]="{'filters': !getFilterPanelstate()}"
                       *ngIf="col.displayWhenFilterPanelOpen == 'true' || getFilterPanelstate()">

                    <div *ngIf="isSortableColumn(col)"
                         class="sortable-table-header"
                         (click)="onSortColumn(col)"
                         [ngStyle]="{'cursor': 'pointer', 'user-select': 'none', 'display': 'contents'}">
                      <div>
                        <div *ngIf="col.displayColumnText">
                          {{col.displayColumnText | translate}}
                        </div>
                        <div *ngIf="!col.displayColumnText">
                          {{col.translateColumnName | translate}}
                        </div>
                      </div>
                      <i class="p-sortable-column-icon pi pi-fw"
                         [ngClass]="{'pi-sort-up':  isSortUp(col),
                                                'pi-sort-down': !isSortUp(col),
                                                'pi-sort': isSortMiddle(col)}">
                      </i>
                    </div>

                    <div *ngIf="!isSortableColumn(col)">
                      <div *ngIf="col.displayColumnText">
                        {{col.displayColumnText | translate}}
                      </div>
                      <div *ngIf="!col.displayColumnText">
                        {{col.translateColumnName | translate}}
                      </div>
                    </div>

                  </div>
                </ng-container>

                <div class="column Flexbox Auto_Column_Notes"
                     *ngIf="testTableData.showNotes
                                      && ['aberrationtype'].indexOf(selectedModality.toLowerCase()) > -1
                                      && getFilterPanelstate()">
                  {{'Notes' | translate}}
                </div>

                <ng-container *ngFor="let opinion of aberrationsCtrl.opinions">
                  <div class="column opinion Flexbox"
                       *ngIf="resourcesConfigs[currentModality]?.showSelectionSection !== false &&
                                            ( (opinion.isSecondOpinion == undefined && opinion.state != 'review')
                                          || aberrationsCtrl.secondOpinionsVisible == undefined
                                          || aberrationsCtrl.secondOpinionsVisible == true
                                          || opinion.practitioner.reference == performer)">
                    {{opinion.practitioner.name}}
                  </div>
                </ng-container>
              </section>

              <!-- For each aberration that is visible-->
              <ng-container *ngFor="let aberration of highlighted; let index=index; trackBy: rowData">
                <section *ngIf="(index >= startIndex && index <= endIndex) && aberrationsCtrl.opinions && isFiltered(aberration)"
                         class="aberration-row Flexbox Flexbox__box-direction-column scroll-target"
                         [ngClass]="{'selected': aberrationsCtrl.currentOpinion?.selections[aberration.id]}">

                  <div class="aberration-basic Flexbox" (click)="openAberrationDetails(aberration)">

                    <div class="column Flexbox">
                      <!--Button to show extra details-->
                      <button type="button" class="btn-icon"
                              (click)="getAberrationInfo(aberration)"
                              *ngIf="!resourcesConfigs[currentModality]?.hideExtraInfo && !testTableData.aberrationExtraDetails"
                              title="{{getTooltip('magnifyGlass')}}">
                        <span [ngClass]="!collapsed[aberration.id] ? 'icon__zoom-in' : 'icon__zoom-out'"></span>
                      </button>
                    </div>

                    <ng-container *ngFor="let col of testTableData.displayColumns[currentModality]">
                      <ng-container
                        *ngIf="col.displayWhenFilterPanelOpen == 'true' || getFilterPanelstate()">
                        <div class="column Flexbox {{col.className}}">
                          <gen-aberration-column class="content-width"
                                                 [columnValue]="aberration"
                                                 [searchTerm]="aberrationsCtrl.abberationsSearchText"
                                                 [tooltipEnabled]="isTooltipEnabled(col)"
                                                 [setColumnData]="col">
                          </gen-aberration-column>
                        </div>
                      </ng-container>
                    </ng-container>

                    <div class="column Flexbox Auto_Column_Notes"
                         *ngIf="testTableData.showNotes
                                              && ['aberrationtype'].indexOf(selectedModality.toLowerCase()) > -1
                                              && getFilterPanelstate()">
                      <gen-aberration-comments [aberration]="aberration"
                                               [lastTooltipText]="aberration.lastNoteText"
                                               [titleConfig]="notesConfig[currentModality]"
                                               (noteAddedEmit)="updateNote($event, aberration)">
                      </gen-aberration-comments>
                    </div>

                    <!-- For each opinion-->
                    <ng-container *ngFor="let opinion of aberrationsCtrl.opinions">

                      <ng-container *ngIf="!resourcesConfigs[currentModality]?.hideExtraInfo && (aberrationsCtrl.secondOpinionsVisible == undefined
                                                 || aberrationsCtrl.secondOpinionsVisible == true || opinion.practitioner.reference == performer || (opinion.isSecondOpinion == undefined && opinion.state != 'review'))">
                        <div class="column opinion Flexbox sticky">
                          <ng-container [ngSwitch]="getOpinionState(opinion)">

                            <!--If state is review we show the switch-->
                            <div *ngSwitchCase="'review'">
                              <dls-toggle-switch
                                [(ngModel)]="opinion.selections[aberration.id]"
                                (click)="select($event, aberration, opinion)"
                                [class.pt-selected]="opinion.selections[aberration.id]">
                              </dls-toggle-switch>
                            </div>

                            <!--If not review state we show the circles-->
                            <div *ngSwitchDefault
                                 [ngSwitch]="opinion.selections[aberration.id]">
                                                          <span *ngSwitchCase="true"
                                                                class="aberration-confirmed icon__check"></span>
                              <span *ngSwitchDefault
                                    class="aberration-rejected icon__minus"></span>
                            </div>

                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>

                  </div>

                  <!--Extra details row-->
                  <div class="Flexbox extra-details-padding"
                       *ngIf="!resourcesConfigs[currentModality]?.hideExtraInfo"
                       [ngClass]="{'selected': aberrationsCtrl.currentOpinion?.selections[aberration.id]}">

                    <div colspan="100%" rowspan="3" class="colspan-style">

                      <div class="aberration-info" *ngIf="collapsed[aberration.id]">

                        <div class="aberration-details extra-details-width"
                             translate-namespace="annotation">

                          <ng-container *ngFor="let category of getKeys(aberration.extra)">
                            <div class="Flexbox Spacebox__tiny"
                                 *ngIf="shouldDisplayCategory(aberration.extra[category].preTranslationCategory)">

                              <div class="extra-detail-column extra-detail-category">{{category}}</div>

                              <div class="Flexbox flex-wrap-wrap content-width">
                                <div class="aberration-extra-detail"
                                     *ngFor="let ann of aberration.extra[category].annotations; trackBy: annData">
                                  <ng-container
                                    *ngIf="shouldDisplayAnnotation(aberration.extra[category].preTranslationCategory, ann)">

                                    <div *ngFor="let annParam of annotParams(ann); trackBy: annParamData">

                                      <span class="extra-detail-column extra-detail-key word-style">{{getAnnotation(annParam.name)}} </span>

                                      <span *ngIf="!isUrl(annParam.value) && annParam.name != 'COSMIC ID'"
                                            genTooltip
                                            [tooltipText]="annParam.value"
                                            [tooltipPosition]="'TOP'"
                                            [tooltipShow]="annParam.value.length > 20"
                                            class="extra-detail-column extra-detail-val">{{annParam.value}}</span>

                                      <a target="_blank"
                                         title="{{annParam.value}}"
                                         href="{{annParam.value}}"
                                         *ngIf="isUrl(annParam.value) && annParam.name != 'COSMIC ID'"
                                         class="extra-detail-val">{{annParam.value}}</a>

                                      <span *ngIf="annParam.name === 'COSMIC ID' && !cosmOrCosn(annParam.value)"
                                            target="_blank"
                                            genTooltip
                                            [tooltipText]="getTooltipText()"
                                            [tooltipPosition]="'LEFT'"
                                            [tooltipShow]="true"
                                            class="extra-detail-column extra-detail-val">{{annParam.value}}</span>

                                      <a *ngIf="annParam.name === 'COSMIC ID' && cosmOrCosn(annParam.value)"
                                         target="_blank"
                                         genTooltip
                                         [tooltipText]="getTooltipText()"
                                         [tooltipPosition]="'LEFT'"
                                         [tooltipShow]="true"
                                         href="{{cosmicURL(annParam.value)}}"
                                         class="extra-detail-column extra-detail-val-link">{{annParam.value}}</a>

                                    </div>
                                  </ng-container>
                                </div>
                              </div>

                            </div>
                          </ng-container>

                          <div *ngIf="aberration.links !== undefined"
                               class="Flexbox Spacebox__tiny content-width">

                            <div class="extra-detail-column extra-detail-category">Web
                              Search
                            </div>

                            <div class="Flexbox flex-wrap-wrap content-width">
                              <div class="aberration-extra-detail">
                                <ng-container *ngFor="let link of aberration.links">

                                  <a [ngClass]='link.classes'
                                     *ngIf="link.config.label !== undefined"
                                     class="extra-detail-column extra-detail-key-link"
                                     href="{{link.href}}"
                                     target="_blank">{{link.config.label}}</a>

                                  <a [ngClass]='link.classes'
                                     *ngIf="link.config.labelHtml !== undefined"
                                     class="extra-detail-column extra-detail-key-link"
                                     href="{{link.href}}" target="_blank"
                                     ng-bind-html="link.config.labelHtml"></a>

                                  <span class="extra-detail-column extra-detail-val"></span>
                                </ng-container>
                              </div>
                            </div>

                          </div>

                          <span (click)="openAberrationDetails(aberration, true)"
                                *ngIf="showIgv"
                                class="fs6_5 pointer Spacebox__t-small genome-browser">View in genome browser
                                                    </span>

                        </div>

                      </div>

                    </div>

                  </div>

                </section>
              </ng-container>

            </article>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
